import { render, staticRenderFns } from "./minepic.vue?vue&type=template&id=bcfc075c&scoped=true&"
import script from "./minepic.vue?vue&type=script&lang=js&"
export * from "./minepic.vue?vue&type=script&lang=js&"
import style0 from "./minepic.vue?vue&type=style&index=0&id=bcfc075c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcfc075c",
  null
  
)

export default component.exports